<template>
  <ComplianceLayout page="privacy-policy">
    <h1>Privacy Policy</h1>
    <h2>Introduction</h2>
    <p>This Privacy Policy explains how this website collects, uses, and protects information when users access our content.</p>
    <p>By using this website, you agree to the terms outlined below.</p>
    <h2>Information We Collect</h2>
    <p>We may collect limited non-personal information such as:</p>
    <ul>
      <li>Browser type</li>
      <li>Device information</li>
      <li>Operating system</li>
      <li>Referral pages</li>
      <li>Anonymous usage statistics</li>
    </ul>
    <p>We do not intentionally collect sensitive personal information.</p>
    <h2>Cookies</h2>
    <p>This website may use cookies to:</p>
    <ul>
      <li>Improve user experience</li>
      <li>Analyze traffic and performance</li>
      <li>Remember basic preferences</li>
    </ul>
    <p>Users can disable cookies through their browser settings.</p>
    <h2>Third-Party Services</h2>
    <p>We may use third-party services including:</p>
    <ul>
      <li>Analytics providers</li>
      <li>Advertising partners</li>
      <li>CDN or hosting providers</li>
    </ul>
    <p>These services may collect anonymous technical data according to their own privacy policies.</p>
    <h2>External Links</h2>
    <p>Our website may contain links to third-party websites or applications.</p>
    <p>We are not responsible for the privacy practices or content of external websites.</p>
    <h2>Data Security</h2>
    <p>We take reasonable measures to protect website data and prevent unauthorized access.</p>
    <p>However, no internet transmission method is completely secure.</p>
    <h2>Children’s Privacy</h2>
    <p>This website is not directed toward children under 13 years old.</p>
    <p>We do not knowingly collect personal information from children.</p>
    <h2>Policy Updates</h2>
    <p>This Privacy Policy may be updated periodically without prior notice.</p>
    <p>Users are encouraged to review this page regularly.</p>
  </ComplianceLayout>
</template>

<script>
import ComplianceLayout from '@/components/ComplianceLayout.vue';

export default {
  name: 'PrivacyPolicyPage',
  components: {
    ComplianceLayout,
  },
};
</script>
